import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Select } from 'antd';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

import styles from './styles.module.css';

import { getCropName } from '../../utils/crops';

export const CropsSelect = ({ t, cropsList, currentCrop = '', isFilter = false, changeCrop, size = '' }) => {
  const { crops } = useSelector((state) => state.catalog);
  const [filterCrop, setFilterCrop] = useState(
    currentCrop
      ? {
          id: currentCrop,
          color: currentCrop !== 'all' ? crops.filter((item) => item.id === currentCrop)[0]?.color : 'transparent',
        }
      : {
          id: 'all',
          color: 'transparent',
        },
  );
  const [list, setList] = useState([]);

  const onChangeFilterCrop = (value) => {
    const selectedCrop = {
      id: value,
      color: value === 'all' ? 'transparent' : list.filter((item) => item.id === value)[0].color || '#ccc',
    };
    setFilterCrop(selectedCrop);
    changeCrop(selectedCrop);
  };

  useEffect(() => {
    if (!cropsList) {
      const fullCropsList = [];
      crops.map((item) => {
        fullCropsList.push({
          id: item.id,
          color: item.color,
        });
      });
      setList(fullCropsList);
      if (!currentCrop) {
        setFilterCrop(fullCropsList[0]);
      }
    } else {
      setList(cropsList);
    }
  }, [cropsList, crops, currentCrop]);

  return (
    <>
      <Select
        value={filterCrop.id}
        suffixIcon={<CroplerIcon name="down" />}
        placeholder={t('cropsContent.select')}
        className={`${styles.cropSelect}`}
        onChange={onChangeFilterCrop}
        size={size}
      >
        {isFilter ? <Select.Option value="all">{t('crops.all')}</Select.Option> : ''}
        {list
          ? list.map((obj) => {
              const name = getCropName({ t, id: obj.id });
              return (
                <Select.Option key={obj.id} value={obj.id}>
                  <span className={styles.crop} title={name}>
                    <span className={styles.cropIcon} style={{ color: obj.color }}></span>
                    <span className={styles.cropText}>{name}</span>
                  </span>
                </Select.Option>
              );
            })
          : ''}
      </Select>
    </>
  );
};
